export const role = {
  role_list_title: 'Liste des rôle',
  role_translation_title: 'Traductions des rôles',
  role_title: 'Titre du rôle',
  load_translation_error: 'Erreur lors du chargement des details des traductions'
};
